import { DealName } from './DealName';

export default DealName;
